import * as React from 'react';


export default class Attach extends React.Component {
  constructor(props){
    super(props);
  }
  render() {
    return (
      <svg viewBox='0 0 16 16' className={this.props.className} xmlnsXlink="http://www.w3.org/1999/xlink">
        <g id="Group" transform="translate(1.000000, 1.000000)">
           
            <polyline id="Page-1-Copy-2" strokeLinecap="round" strokeLinejoin="round" points="8.19257932 4.18472121 3.62842053 7.69393445 5.28407731 9.83654911 12.7099901 4.18472121 9.00911029 1.04805054e-13 0 7.45006595 5.11344727 13.6106674 13.6106674 6.89064874"></polyline>
        </g>
      </svg>
    )
  }
}
